import { render, staticRenderFns } from "./changedetail.vue?vue&type=template&id=766f439e&scoped=true"
import script from "./changedetail.vue?vue&type=script&lang=js"
export * from "./changedetail.vue?vue&type=script&lang=js"
import style0 from "./changedetail.vue?vue&type=style&index=0&id=766f439e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f439e",
  null
  
)

export default component.exports